import { createContext } from "react";

export const EditorActiveContext = createContext(false);
